export function isBrowser(): boolean {
  return typeof window !== "undefined";
}

export function isServer(): boolean {
  return !isBrowser();
}

export const isDev = isBrowser()
  ? window.location.href.indexOf("dev.travellocal.com") > -1 // TODO be better
  : process?.env?.NODE_ENV && process.env.NODE_ENV === "development";

/**
 * Whether the browser supports the object-fit CSS property
 * https://caniuse.com/#feat=object-fit
 */
export const supportsObjectFit = () => {
  return isBrowser() && "objectFit" in document.documentElement.style && window.location.search.indexOf("no-of") < 0;
};

export const supportsIntersectionObserver = () => {
  return isBrowser() && ("IntersectionObserver" in window);
};
